import AdminLayout from "../../../components/admin/layout/AdminLayout";
import {useParams} from "react-router-dom";
import React from "react";
import AdminWorkerRequest from "../../../components/admin/billing/AdminWorkerRequest";

//작업자 추가 요청 상세 페이지
const AdminWorkerRequestPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //작업자 추가 요청 식별자가 없는 경우
    if (!id) {
        return <div>Invalid request ID</div>;
    }

    return (
        <AdminLayout>
            {/*작업자 추가 요청 상세 페이지 버튼*/}
            <AdminWorkerRequest workerRequestId={parseInt(id)}/>
        </AdminLayout>
    )
}
export default AdminWorkerRequestPage;